<div class="bg-white p-1 p-md-4">
  <h3 class="text-center font-weight-bold">
    @if (isInTrial) {
      <span
        [innerHTML]="'web.user_dashboard_headline' | translate | markdown"
        class="emph-text-dashboard"
      ></span>
    }
    @if (!isInTrial) {
      <span
        [innerHTML]="'web.user_dashboard_headline_not_trial' | translate | markdown"
        class="emph-text-dashboard"
      ></span>
    }
  </h3>
  <app-pricing></app-pricing>
  <div
    class="user-dashboard-text my-6 text-center emph-text-dashboard"
    [innerHTML]="'web.dashboard-promo-text' | translate | markdown"
  ></div>

  <div>
    <strong>{{ 'web.last_sign_in' | translate }}</strong>
    @if (lastSign$ | async; as time) {
      <span>
        {{ time | livDate : 'dateShort' }}
      </span>
    }
  </div>
</div>
